export enum StudyReportCircuitEnum {
  DirectTypingWeb = 7
}
